import clsx from 'clsx'
import React from 'react'
import { createUseStyles } from 'react-jss'

import { LG } from '../constants/mediaQueries'

const useStyles = createUseStyles({
  line: {
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    transition: 'top 0.3s ease, bottom 0.3s ease, left 0.3s ease, right 0.3s ease',
    zIndex: 9
  },
  horizontal: {
    left: 0,
    width: '100%',
    height: 1
  },
  vertical: {
    top: 0,
    height: '100%',
    width: 1
  },
  topOffset: {
    top: 30,
    [LG]: {
        top: 50
    }
  },
  bottomOffset: {
    bottom: 30,
    [LG]: {
        bottom: 50
    }
  },
  leftOffset: {
    left: 30,
    [LG]: {
        left: 'min(24.31%, 350px)',
    }
  },
  rightOffset: {
    right: 30,
    [LG]: {
        right: 'min(24.31%, 350px)',
    }
  },

})

const BackgroundLines = () => {
  const classes = useStyles()

  return (
    <>
      <div className={clsx(classes.line, classes.horizontal, classes.topOffset)} />
      <div className={clsx(classes.line, classes.horizontal)} style={{ top: '50%' }} />
      <div className={clsx(classes.line, classes.horizontal, classes.bottomOffset)} />
      <div className={clsx(classes.line, classes.vertical, classes.leftOffset)} />
      <div className={clsx(classes.line, classes.vertical, classes.rightOffset)} />
    </>
  )
}

export default BackgroundLines
